import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@adc/ui-core'
import _ from 'lodash'
import classNames from 'classnames/bind'
import { InvestorPreferences } from '../../../../../util'
import styles from './styles.scss'
const cx = classNames.bind(styles)

class LocationPills extends Component {
  static propTypes = {
    removeValue: PropTypes.func.isRequired,
    elmId: PropTypes.string.isRequired,
    value: PropTypes.array.isRequired,
  }

  static defaultProps = {
    removeValue: _.noop,
    elmId: 'pill',
    value: [],
  }

  render() {
    const { value: values, removeValue, elmId } = this.props

    return (
      <div className={cx('location-pills')}>
        {values.map((val, i) => {
          const label = InvestorPreferences.placeToLabel(val)

          return (
            <span
              key={i}
              className={cx('filter-pills')}
              data-elm-id={`${elmId}_${i}`}
            >
              {label}
              <Icon
                data-elm-id={`${elmId}_close_${i}`}
                className={cx('icon-close')}
                name='times'
                iconStyle='light'
                color='grayMedium'
                onClick={removeValue(val)}
              />
            </span>
          )
        })}
      </div>
    )
  }
}

export default LocationPills
